<template>
  <div class="pass" v-if="pass || skip">
    <!-- This pass message is defined in the parent. It contains bespoke information based on the particular test -->
    <slot name="message"></slot>
    <div class="move-on">
      <prev-next :direction="'prev'" :icon="'fa-arrow-left'" :url='previousPage'></prev-next>
      <prev-next :direction="'next'" :icon="'fa-arrow-right'" :url='nextPage' :finalTest="finalTest"></prev-next>
    </div>
  </div>
</template>

<script>
  import PrevNextButton from './PrevNextButton.vue'
  /**
  * Component that renders a bespoke pass message, delivered from the parent page and rendered in the 'message' Slot
  * Also renders buttons to navigate to the next or previous test
  */
  export default {
    name: 'Pass',
    components: {
      'prev-next': PrevNextButton
    },
    props: {
      /**
      * Boolean - Whether the test has been passed or not
      */
      'pass': {
        'type': Boolean,
        'default': false
      },
      /**
      * Boolean - Whether the test has been skipped or not
      */
      'skip': {
        'type': Boolean,
        'default': false
      },
      /**
      * String - url of the previous test
      */
      'previousPage': {
        'type': String,
        'default': 'previous'
      },
      /**
      * String - url of next test
      */
      'nextPage': {
        'type': String,
        'default': 'next'
      },
      /**
      * Boolean - True if this applies to the last test
      */
      'finalTest': {
        'type': Boolean,
        'default': false
      }
    }
  }
</script>

<style scoped></style>
